<template lang="pug">
    v-container( fluid pa-0 ma-0 )
        v-row
            v-col(align="center" class="tw-p-0 tw-m-0")
                apexchart( 
                    :options="options"
                    :series="options.series"
                    :type="options.chart.type"
                    width="90%"
                    class=" tw-p-0 tw-m-0"
                )
</template>

<script>
    export default {
        data() {
            return {
                options: {
                    series: [75],
                    chart: {
                        type: 'radialBar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -90,
                            endAngle: 90,
                            hollow: {
                                margin: 90,
                                size: '75%',
                                background: 'transparent',
                            },
                            track: {
                                margin: 0,
                                background: '#fff',
                                strokeWidth: '98%',
                                position: 'front',
                                dropShadow: {
                                    enabled: true,
                                    top: 4,
                                    left: 2,
                                    blur: 4,
                                    opacity: 0.09,
                                },
                            },
                            dataLabels: {
                                name: {
                                    offsetY: -50,
                                    show: true,
                                    color: '#888',
                                    fontSize: '17px',
                                },
                                value: {
                                    formatter: function(val) {
                                        return parseInt(val);
                                    },
                                    color: '#111',
                                    fontSize: '28px',
                                    offsetY:-40,
                                    show: true,
                                },
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.9,
                            gradientToColors: ['#ABE5A1'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100],
                        },
                    },
                    grid:{
                        show:true,
                        padding:{
                            top:-20,
                            bottom: 0,
                            left:-90,
                            right:-90
                        },
                    },
                    stroke: {
                        lineCap: 'round',
                        
                    },
                    labels: ['Percent'],
                },
            };
        },
    };
</script>